import React from 'react'
import { Link } from 'react-static'
import styled from 'styled-components'
import { Flex, Box, PressButton, Icon, Container } from 'components'

const NavLink = styled(Link)`
  margin: .6rem 2rem .6rem 0;
  padding: .2rem 0;
  display: inline-block;
  &[aria-current=true], &:hover, &.active {
    box-shadow:0px 3px 0px;
  }
`

const Navigation = () => (
  <Container maxWidth="large" pt={3}>
    <Flex is="nav" alignItems="center" justifyContent="space-between">
      <NavLink mt={20} to="/" exact>
        <Icon name="logo" color="primary.0" width={40} height={20} viewBox="0 0 32 16" />
      </NavLink>
      <Box>
        <NavLink mr={4} to="/writing">Writing</NavLink>
        {/* <NavLink to="/about">About</NavLink> */}
        <Link to="/working">
          <PressButton type="button" py={2} px={3}>Work Together?</PressButton>
        </Link>
      </Box>
    </Flex>
  </Container>
)

export default Navigation



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Navigation.js